import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getCookie, Typography } from '@chilecompra/react-kit'

import BrandLayout from '../../components/Layouts/BrandLayout'
import routes from '../../config/settings/routes'
import { initializeReCaptcha } from '../../modules/hooks/reCaptcha'

import AuthorizationContext from '../../containers/AuthProvider/AuthProvider.context'
import AuthorizationProviderContainer from '../../containers/AuthProvider/AuthProvider.container'
import DirectDealPageHeader from '../../containers/DirectDealPageHeader/DirectDealPageHeader.container'
import DirectDealSearch from '../DirectDealSearch/DirectDealSearch'
import DirectDealStepOneContainer from '../../containers/DirectDealStepOne/DirectDealStepOne.container'
import NotFound from '../NotFound/NotFound'
import ProtectByProfile from '../../components/Security/ProtectByProfile'
import ProtectByStep from '../../components/Security/ProtectByStep'
import StepFlowProviderContainer from '../../containers/StepFlowProvider/StepFlowProvider.container'
import StepFlowProviderContext from '../../containers/StepFlowProvider/StepFlowProvider.context'

import { Grid } from './DirectDealStepOne.styles'

import { PROTECT_BY_STEP_DICTIONARY } from '../../config/settings/constants'

/**
 * The DirectDealStepOne's page.
 */
const DirectDealStepOne = () => {
  const navigate = useNavigate()

  const directDealheading = {
    breadcrumbs: [
      {
        text: 'Escritorio',
        onRedirectTo: () => {
          const query = getCookie('search')
          navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
        }
      },
      {
        text: 'Trato Directo',
        onRedirectTo: () => {
          const query = getCookie('search')
          navigate({ pathname: routes.search, search: query.toString() }, { replace: true })
        }
      },
      {
        text: 'Crear Trato Directo'
      }
    ],
    step: 'PASO 1 DE 2',
    title: 'Crear nuevo Trato Directo',
    description: (
      <Typography color="black1" margin="5px 0 16px" variant="body2" tabIndex="0">
        Ingresa toda la información del Trato Directo que deseas realizar, la causal, justificación, productos o
        servicios, entre otros.
        <br />
        Al finalizar podrás continuar con la emisión de la orden de compra.
      </Typography>
    )
  }

  return (
    <AuthorizationProviderContainer>
      <AuthorizationContext.Consumer>
        {({ isPrivated }) => {
          if (isPrivated) initializeReCaptcha()
          return (
            <ProtectByProfile rule={userType => userType === 'Comprador'} fallback={() => <NotFound />}>
              <ProtectByStep step={PROTECT_BY_STEP_DICTIONARY.STEP_ONE} fallback={() => <DirectDealSearch />}>
                <StepFlowProviderContainer>
                  <StepFlowProviderContext.Consumer>
                    {() => (
                      <BrandLayout featured={<DirectDealPageHeader {...directDealheading} />}>
                        <Grid container>
                          <Grid item xs={12} md={12}>
                            <DirectDealStepOneContainer />
                          </Grid>
                        </Grid>
                      </BrandLayout>
                    )}
                  </StepFlowProviderContext.Consumer>
                </StepFlowProviderContainer>
              </ProtectByStep>
            </ProtectByProfile>
          )
        }}
      </AuthorizationContext.Consumer>
    </AuthorizationProviderContainer>
  )
}

export default DirectDealStepOne
